import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 客户角色码
 */
class RoleCode extends UltMeta {
    CUSTOMER = new Meta(1, "采购商");
    SUPPLIER = new Meta(2, "供应商");
    SUPPLY_CHAIN = new Meta(3, "联合购销商");
    CARRIER = new Meta(4, "承运商");
}

/**排序 */
class SortOrder extends UltMeta {
    ASC = new Meta(0, "升序");
    DESC = new Meta(1, "降序");
}

/**组织机构类型 */
class OrgStructure extends UltMeta {
    PERSONAL = new Meta(1, "个人");
    ENTERPRISE = new Meta(2, "企业");
}

/**银行认证类型 */
class BankCert extends UltMeta {
    PERSONAL = new Meta(1, "对公账户");
    ENTERPRISE = new Meta(2, "个人账户");
}

/**
 * 抬头类型
 * 1 企业
 * 2 个人/事业单位
 */

class InvoiceHeader extends UltMeta {
    PERSONAL = new Meta(2, "个人");
    ENTERPRISE = new Meta(1, "企业");
}

/**
 * 发票类型
 * 1. 普通发票
 * 2. 增值税专用发票
 */
class Invoice extends UltMeta {
    NORMAL = new Meta(1, "普通发票");
    VAT = new Meta(2, "增值税专用发票");
}

/**
 * 查找类型
 * 1. 船舶关联查询
 * 2. 购买意向
 */
class FindType extends UltMeta {
    SHIP_CARRIER = new Meta(1, "船舶关联查询");
    PURCHASE_DEMAND = new Meta(2, "购买意向");
}
class MembershipLevel extends UltMeta {
    NON_MEMBER = new Meta(1, "非会员");
    BASE = new Meta(2, "基础会员");
    SENIOR = new Meta(3, "高级会员");
    ENTERPRISE_GRADE = new Meta(4, "企业会员");
}
class MemberState extends UltMeta {
    ACTIVE = new Meta(1, "激活");
    EXPIRY = new Meta(2, "过期");
}

export const ROLE_CODE = new RoleCode();
export const SORT_ORDER = new SortOrder();
export const ORG_STRUCTURE = new OrgStructure();
export const BANK_CERT = new BankCert();
export const INVOICE_HEADER = new InvoiceHeader();
export const INVOICE = new Invoice();
export const FIND_TYPE = new FindType();
export const MEMBERSHIP_LEVEL = new MembershipLevel();
export const MEMBER_STATE = new MemberState();
